module.exports = __webpack_public_path__ + "static/media/30OIOS1.0fa4b6af.jpg";